// extracted by mini-css-extract-plugin
export default {"pageRoot":"CustomPrivacyPolicyPage_pageRoot__j37aT","content":"CustomPrivacyPolicyPage_content__zfbGf","info":"CustomPrivacyPolicyPage_info__MKviA"};